import { useCallback, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export function PortalStartupsModule() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    api.get("/portal/admin/startups").then((r) => setItems(r.data)).catch((e) => toast.error(formatApiError(e))).finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="admin-startups-module">
      <div className="mb-6">
        <h2 className="font-display text-2xl font-bold text-white">Startup Projects</h2>
        <p className="text-sm text-slate-400">{items.length} startup projects registered on the portal</p>
      </div>
      {loading ? (
        <div className="flex justify-center py-16"><div className="w-8 h-8 rounded-full border-2 border-[#FF8800] border-t-transparent animate-spin" /></div>
      ) : items.length === 0 ? (
        <div className="glass rounded-xl p-12 text-center text-slate-400">No startups registered yet.</div>
      ) : (
        <div className="space-y-3">
          {items.map((s) => (
            <div key={s.id} className="glass rounded-xl p-4 flex flex-col sm:flex-row sm:items-center gap-4" data-testid={`startup-row-${s.id}`}>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <p className="font-display font-semibold text-white">{s.name}</p>
                  <span className={`text-[10px] font-mono-tech px-2 py-0.5 rounded-full border ${s.status === "submitted" ? "border-[#00E676]/40 text-[#00E676]" : "border-slate-500/40 text-slate-500"}`}>{s.status.toUpperCase()}</span>
                  <span className={`text-[10px] font-mono-tech px-2 py-0.5 rounded-full border ${s.ai_status === "ready" ? "border-[#00B0FF]/40 text-[#00B0FF]" : s.ai_status === "analyzing" ? "border-[#FF8800]/40 text-[#FF8800]" : "border-slate-500/40 text-slate-500"}`}>
                    AI: {s.ai_status.toUpperCase()}
                  </span>
                </div>
                <p className="text-xs text-slate-400 mt-1">{s.owner_name} · {s.owner_email} · {s.industry || "—"} · {s.created_at ? new Date(s.created_at).toLocaleDateString("en-IN") : ""}</p>
              </div>
              {s.score != null && (
                <div className="shrink-0 text-center">
                  <p className="font-display font-extrabold text-xl text-gradient-saffron">{s.score}</p>
                  <p className="text-[9px] font-mono-tech text-slate-500 tracking-widest">AI SCORE</p>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
